// Authentication utility functions for subscription service

export const authUtils = {
  // Store authentication tokens and user data
  storeAuthTokens: (data) => {
    if (data.token) {
      localStorage.setItem('authToken', data.token);
    }
    if (data.user) {
      localStorage.setItem('currentUser', JSON.stringify(data.user));
    }
  },

  // Get stored authentication data
  getStoredAuthData: () => {
    const token = localStorage.getItem('authToken');
    const userStr = localStorage.getItem('currentUser');
    const user = userStr ? JSON.parse(userStr) : null;
    
    return {
      token,
      user
    };
  },

  // Clear authentication tokens
  clearAuthTokens: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUser');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('authToken');
    return !!token;
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem('currentUser');
    return userStr ? JSON.parse(userStr) : null;
  }
};
